<template>
    <el-container class="openClfxxByERM">
        <el-header>挂牌房源信息</el-header>
        <el-main>
            <el-row :span="24">
                <template>
                    <el-carousel :interval="5000" arrow="always" >
                        <el-carousel-item v-for="item in clfImgList">
                            <el-image class="imgClf"
                                      :src="item.imgurl"
                                      :preview-src-list="srcList"
                            ></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </template>
            </el-row>
            <el-row  class="mainSjBody">
                <el-row :span="24" :offset="1">
                    <el-row>
                        {{fwxxList.XQMC}}
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-row>
                                <span class="SpancontentFyhybm">
                                    房源核验唯一编码：
                                </span>
                                <span class="SpancontentFyhy">
                                    {{fwxxList.FYHYBM}}
                                </span>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <div>
                        <div slot="header" class="clearfix">
                            <div class="headFirst"></div>
                            <div class="headSecond">基本信息</div>
                        </div>
                        <el-row>
                            <el-col :span="24" class="Spanfwzj">
                                <span>
                                    {{fwxxList.FWZJ}}元
                                </span>
                            </el-col>
                            <el-col :span="24" class="SpanFwdz">
                                <span >
                                     {{fwxxList.FWDZ}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <span class="Spancontent1">
                                    所属城区：
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.SSCQ}}
                                </span>
                            </el-col>
                            <el-col :span="24">
                                <span class="Spancontent1">
                                    用途类型：
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.YTLX}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <span class="Spancontent1">
                                    建筑面积：
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.JZMJ}}
                                </span>
                            </el-col>
                            <el-col :span="24">
                                <span class="Spancontent1">
                                    挂牌时间：
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.GPSJ}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <span class="Spancontent1">
                                    所在楼层：
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.SZLC}}
                                </span>
                            </el-col>
                            <el-col :span="24">
                                <span class="Spancontent1">
                                    装修程度：
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.ZXCD}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                    </div>
                    <div>
                        <div slot="header" class="clearfix">
                            <div class="headFirst"></div>
                            <div class="headSecond">挂牌经纪人信息</div>
                        </div>
                        <div  class="JJRXXDiv">
                            <el-col :span="6">
                                <el-image class="imgJJR"
                                          :src="jjryList.JJRPHOTO"
                                ></el-image>
                            </el-col>
                            <el-col :span="18">
                                <el-row>
                                <span class="jjrgrmc">
                                    {{jjryList.GRMC}}
                                </span>
                                </el-row>
                                <el-row>
                                <span class="Spancontent1">
                                    经纪人编号：
                                </span>
                                    <span class="Spancontent2">
                                    {{jjryList.ZJHM}}
                                </span>
                                </el-row>
                                <el-row>
                                <span class="Spancontent1">
                                    从业时间：
                                </span>
                                    <span class="Spancontent2">
                                    {{jjryList.CYSJ}}
                                </span>
                                </el-row>
                            </el-col>
                        </div>
                    </div>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                    <div  class="JJJGXX">
                        <div class="headFirst"></div>
                        <div class="headSecond">挂牌机构信息</div>
                        <el-row>
                                <span class="Spancontent1">
                                    挂牌机构名称：
                                </span>
                            <span class="Spancontent2">
                                    {{tableData.jgmc}}
                                </span>
                        </el-row>
                        <el-row>
                                <span class="Spancontent1">
                                    备案编号：
                                </span>
                            <span class="Spancontent2">
                                    {{tableData.babh}}
                                </span>
                        </el-row>
                        <el-row>
                                <span class="Spancontent1">
                                    联系电话：
                                </span>
                            <span class="Spancontent2">
                                    {{tableData.lxdh}}
                                </span>
                        </el-row>
                        <el-row>
                                <span class="Spancontent1">
                                    门店地址：
                                </span>
                            <span class="Spancontent2">
                                    {{tableData.mddz}}
                                </span>
                        </el-row>
                        <el-row>
                                <span class="Spancontent1">
                                    其他挂牌机构家数：
                                </span>
                            <span class="Spancontent2">
                                    {{tableData.qtgpjgs}}
                                </span>
                        </el-row>
                    </div>
                </el-row>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
	import axios from 'axios';
	import config from "@/config";
	const base_url = config.baseUrl + 'clf/';
    export default {
        name: "openClfxx",
        data() {
            const item = {
                jgmc: '汉中鸿润置业有限公司',
                babh: 'H20210000234',
                lxdh: 'H20210000234',
                mddz:'H20210000234',
                qtgpjgs:'0',
            };
            return {
				fyhybm: 0,
                tableData: item,
                fwxxList:{
                    XQMC:'颐和府',
                    FYHYBM:'123EWDSSD2112',
                    FWZJ:'12343434'.toString().replace(/\B(?=(\d{3})+$)/g,','),
                    FWDZ:'东昌府区金柱大学城东苑',
                    SSCQ:'金柱大学城东苑',
                    JZMJ:'123',
                    SZLC:'23',
                    YTLX:'住宅',
                    GPSJ:'2020-12-21',
                    ZXCD:'精装修',
                    imgUrl: require("../../img2/clf/erweima.jpg"),
                },
                jjryList:{
                  JJRPHOTO: require("../../img2/clf/jjrphoto.png"),
                  GRMC:'张珊珊',
                  ZJHM:'32822332',
                  CYSJ:'2020年',
                  imgurl: require("../../img2/clf/erweima.jpg"),
                },
                clfImgList:[
                    {imgurl: require("../../img2/clf/zwtp.png")},
                    {imgurl: require("../../img2/clf/zwtp.png")},
                ],
                srcList: [
                    require("../../img2/clf/zwtp.png"),
                    require("../../img2/clf/zwtp.png")
                ],
            }
        },
        methods: {
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            tableRowClassName({row, rowIndex}) {
                if ( rowIndex%2 ==0) {
                    return 'success-row';
                } else if (rowIndex%2 !=0) {
                    return '';
                }
                return '';
            },
            ClassName_Biaotou({row, column, rowIndex, columnIndex}) {
                    return 'class_Biaotou';
            },
        },
        created() {
			this.fyhybm = this.$route.query.fyhybm;
			axios.get(base_url + "clfxx_fwxx" + "?fyhybm=" + this.fyhybm).then(response => {
				response.data.imgUrl = require("/src/" + response.data.imgUrl);
				response.data.FWZJ = response.data.FWZJ.toString().replace(/\B(?=(\d{3})+$)/g,',');
				this.fwxxList = response.data;
			}).catch(error => console.log(error, "error"));
			axios.get(base_url + "clfxx_jjry" + "?fyhybm=" + this.fyhybm).then(response => {
				response.data.JJRPHOTO = require("/src/" + response.data.JJRPHOTO);
				response.data.imgUrl = require("/src/" + response.data.imgUrl);
				this.jjryList = response.data;
			}).catch(error => console.log(error, "error"));
			axios.get(base_url + "clfxx_gpjg" + "?fyhybm=" + this.fyhybm).then(response => {
				this.tableData = response.data.length ? response.data[0] : {};
			}).catch(error => console.log(error, "error"));
        },
        /*mounted(){
            this.$http.get("/data.json").then((res) => {
                this.data = res.data;
                this.data.forEach((item) => {
                    this.srcList.push(item.pic);
                });
            });
        },*/
    }
</script>

<style scoped>
    @import "../../assets/css/clf/openClfxxByEWM.css";
</style>